import React from 'react';
import { useTranslation } from 'react-i18next';

import { ResponsiveModalBottomSheet, Button } from '@/components';
import { useBrandStore } from '@/store';

interface TermsAndConditionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
}

const TermsAndConditionsModal: React.FC<TermsAndConditionsModalProps> = ({
  isOpen,
  onClose,
  onAccept,
}) => {
  const { t, i18n } = useTranslation();
  const { getBrandTerms } = useBrandStore();

  const currentLanguage = i18n.language as 'en' | 'th';
  const termsContent = getBrandTerms(currentLanguage);

  return (
    <ResponsiveModalBottomSheet
      heightClass="h-[85vh]"
      isOpen={isOpen}
      onClose={onClose}
      title={t('terms.title')}
      stickyFooter={
        <div className="p-4">
          <Button onClick={onAccept}>{t('terms.accept')}</Button>
        </div>
      }
    >
      <div className="px-4 py-4 pt-2">
        {/* Terms Content */}
        <div className="text-secondary-text leading-6">
          <div
            className="prose prose-sm max-w-none [&_li]:mb-2 [&_ul]:ml-6 [&_ul]:list-disc"
            dangerouslySetInnerHTML={{
              __html: termsContent
                .replace(/\n/g, '<br />')
                .replace(/\*\s/g, '<li>')
                .replace(/<li>/g, '</li><li>')
                .replace(/^<\/li>/, '')
                .replace(/<li>$/, '</li>'),
            }}
          />
        </div>
      </div>
    </ResponsiveModalBottomSheet>
  );
};

export default TermsAndConditionsModal;
